export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "サインイン",
    "login.form.hint.user": "ログイン",
    "login.form.hint.password": "パスワード",
    "login.form.checkbox.remember-me": "ログイン情報を記憶",
    "login.form.button.sign-in": "サインイン",
    "login.form.message.invalid-user-credentials": "ログイン ID またはパスワードが正しくありません",
    "login.form.message.user-required": "ログインIDを入力してください",
    "login.form.message.password-required": "パスワードを入力してください",
    "login.form.button.forgot-password": "パスワードを忘れた場合",
    "error.root-admin-login.title": "エラー 403: 禁止",
    "error.root-admin-login.message": "読み取り専用管理者としてログイン済みです。Web Recovery コンソールにアクセスするには、カスタマーテナントのユーザーまたは管理者としてログインしてください"
};
